import { useMutation, useQueryClient } from '@tanstack/react-query'
import { regenerateSoapFromDictated } from '@/shared/apis/yakureki'
import { queryKeys } from '@/shared/hooks/queries/queryKeys'
import { useToast } from '@/shared/contexts/ToastContext'

// 新 path 専用 mutation (= post_batch dictated → SOAP only LLM 1 call).
//
// back guard:
//   - status != PROCESSING (= 実行中の二重 kick 防止. それ以外の status は不問)
//   - regenerate_count < 3
//   - 話者分離版がもうすぐ来る間 (running / 音声ありの pending) でない
//   - 会話か資料がある
// それ以外は HTTP error (= guard 種別ごとに toast 文言を切替).
//
// apps/latest 配下からのみ使用. 今入っている文字起こし (話者分離版かライブ版) と資料で SOAP を引き直す UX を提供
// (= LLM 出力が不適切なときの user 救済).
export const useRegenerateFromDictatedMutation = () => {
  const queryClient = useQueryClient()
  const { showToast } = useToast()

  return useMutation({
    mutationFn: async (yakurekiId: string) => {
      await regenerateSoapFromDictated(yakurekiId)
    },
    onSuccess: (_, yakurekiId) => {
      // toast は出さない (= PostRecordingView SOAP タブの ProcessingChecklist が
      // 状態表示を担う. polling は index.tsx の refetchInterval で自動継続).
      queryClient.invalidateQueries({
        queryKey: queryKeys.yakureki.detail(yakurekiId),
      })
    },
    onError: (error) => {
      const axiosError = error as {
        response?: { status?: number; data?: { error?: string } }
      }
      const status = axiosError.response?.status
      // guard 失敗 (RegenerateError) は back が日本語 message を返す (= 文言の SSoT).
      const serverMessage = axiosError.response?.data?.error
      if (status === 404) {
        showToast('指定された薬歴が見つかりません', 'error')
      } else if (serverMessage) {
        showToast(serverMessage, 'warning')
      } else if (!navigator.onLine) {
        showToast('ネットワーク接続を確認してください', 'error')
      } else {
        showToast('SOAP 再生成に失敗しました', 'error')
      }
    },
  })
}
